import script from "./BrandedSubHeadingElement.vue.js?vue&type=script&lang=js!=!../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./BrandedSubHeadingElement.vue?vue&type=script&lang=js"
export * from "./BrandedSubHeadingElement.vue.js?vue&type=script&lang=js!=!../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./BrandedSubHeadingElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-components/render-engine/components/production/elements/text-element/BrandedSubHeadingElement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "579c795d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('579c795d', __exports__)) {
    api.reload('579c795d', __exports__)
  }
  
}


export default __exports__